<nav id="navPanel" class="bg-light border-bottom box-shadow fixed-top navbar-expand-lg">
	<app-header></app-header>
</nav>
<div class="main-panel pt-0 pb-4" style="background-color: #ffffff;">
    <div class="container-fluid" #main [style.padding-top.px]="paddingtop">
        <div class="col-sm-12 px-0 align-self-end">
          <div class="row align-items-center">
            <div class="col-sm-10">
              <h5 class="light-header bold">
                {{ 'MYACCOUNT.CHANGE_PASSWORD_LBL_TITLE' | translate}}
              </h5>
            </div>
            <!-- Exit button -->
            <!-- <div class="col-sm-2">
              <button type="button" class="btn btn-primary btn-sm float-right" (click)="exitBtnClickEvent()">
                <i class="fas fa-sign-out"></i> Exit
              </button>
            </div> -->
          </div>
          <hr class="mt-0 mb-3" />
        </div>
        <div class="pt-3">
          <div class="container border rounded p-3 bold col-sm-5">
            <form>
              <div class="form-group row">
                <label for="newpassword" class="col-sm-4 col-form-label">New Password</label>
                <div class="col-sm-8"> 
                    <div class="input-with-icon">
                      <input #new_password id="newpassword" 
                        [type]="showNewPassword ? 'text' : 'password'" class="form-control"
                        name="newpassword" required="" data-eye="" style="padding-right: 60px;"
                        autocomplete="off" placeholder="New Password"
                        [(ngModel)]="newpassword" >
                      <div class="btn btn-default icon" (click)="showNewPassword = !showNewPassword">
                        <i class="fa" aria-hidden="true"
                          [ngClass]="{'fa-eye': !showNewPassword, 'fa-eye-slash': showNewPassword}"></i>
                      </div>
                      <input type="hidden" id="passeye-0">
                    </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="confirmpassword" class="col-sm-4 col-form-label">Confirm Password</label>
                <div class="col-sm-8">
                    <div class="input-with-icon">
                      <input #confirm_password id="confirmpassword" 
                        [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
                        name="confirmpassword" required="" data-eye="" style="padding-right: 60px;"
                        autocomplete="off" placeholder="Confirm Password"
                        [(ngModel)]="confirmpassword" >
                      <div class="btn btn-default icon" (click)="showConfirmPassword = !showConfirmPassword">
                        <i class="fa" aria-hidden="true"
                          [ngClass]="{'fa-eye': !showConfirmPassword, 'fa-eye-slash': showConfirmPassword}"></i>
                      </div>
                      <input type="hidden" id="passeye-0">
                    </div>
                </div>
              </div>   
              <div class="form-group row">
                <div class="col-sm-8"></div>
                <div class="col-sm-4">
                  <button type="button" class="btn btn-primary btn-sm" (click)="saveBtnClickEvent()"> <i class="far fa-save"></i> Save</button>
                  &nbsp;&nbsp;
                  <button type="button" class="btn btn-primary btn-sm" (click)="cancelBtnClickEvent()"> <i class="far fa-times"></i> Cancel</button>
                </div>
              </div>   
            </form>
          </div>
		  </div>
    </div>
  </div>